module.exports = __webpack_public_path__ + "static/media/liudas.1ac9e9ca.png";